import { connect } from 'react-redux';
import { ICopyPanelButtonHOCProps } from './types';
import { onClick } from './events/onClick';
import { CopyPanelButton } from '../../components/CopyPanelButton/CopyPanelButton';
import { ICopyPanelButtonEvents } from '../../components/CopyPanelButton/types';

const mapDispatchToProps = (
    dispatch: any,
    { onClick: ownOnClick }: ICopyPanelButtonHOCProps
): ICopyPanelButtonEvents => {
    return {
        onClick: () => dispatch(onClick(ownOnClick))
    }
};

export const CopyPanelButtonHOC = connect(
    null,
    mapDispatchToProps
)(CopyPanelButton);
